import {useEffect, useState, useCallback, useRef} from "react";
import {DEFAULT_PAGE_SIZE_OPTIONS} from "../utils/pagination";

export default function usePaginationSearch({
  initialFilters = {},
  initialItemsPerPage = DEFAULT_PAGE_SIZE_OPTIONS[0],
  fetcher
}) {
  const [filters, setFilters] = useState(initialFilters);
  const [paginationModel, setPaginationModel] = useState({page: 0, pageSize: initialItemsPerPage});
  const [query, setQuery] = useState({page: 0, limit: initialItemsPerPage, ...initialFilters});

  const [rows, setRows] = useState([]);
  const [totalRows, setTotalRows] = useState(0);

  const fetcherRef = useRef(fetcher);

  useEffect(() => {
    setQuery((prev) => ({
      ...prev,
      page: paginationModel.page,
      limit: paginationModel.pageSize
    }));
  }, [paginationModel]);

  useEffect(() => {
    fetcherRef.current = fetcher;
  }, [fetcher]);

  useEffect(() => {
    fetcherRef.current(query).then((response) => {
      if (!response) return;
      const {data} = response;
      setRows(data?.data);
      setTotalRows(data?.pagination?.totalItems || 0);
    });
  }, [query]);

  const refresh = useCallback(() => {
    fetcherRef.current(query).then(({data}) => {
      setRows(data?.data);
      setTotalRows(data?.pagination?.totalItems || 0);
    });
  }, [query]);

  const setFilter = (key, value) => {
    if (value === undefined || value === null || value === "") {
      setFilters((prev) => {
        const newFilters = {...prev};
        delete newFilters[key];
        return newFilters;
      });
    } else {
      setFilters((prev) => ({...prev, [key]: value}));
    }
  };

  const applyFilters = () => {
    setQuery((prev) => ({
      page: 0,
      limit: prev.limit,
      ...filters
    }));
    setPaginationModel((prev) => ({...prev, page: 0}));
  };

  const resetFilters = () => {
    setFilters(initialFilters);
    setQuery((prev) => ({page: 0, limit: prev.limit, ...initialFilters}));
    setPaginationModel((prev) => ({...prev, page: 0}));
  };

  const dataGridProps = {
    rows,
    rowCount: totalRows,
    paginationMode: "server",
    pagination: true,
    paginationModel,
    onPaginationModelChange: setPaginationModel
  };

  return {
    filters,
    setFilter,
    applyFilters,
    resetFilters,
    refresh,
    dataGridProps
  };
}
